<template>
  <v-menu offset-y>
    <template #activator="{on}">
      <v-toolbar-title v-on="on">
        MiddleWare
        <span style="display: inline-block; border-radius: 20px; padding: 5px 8px 5px 20px; background-color: #3b3b3b">
          {{ account.name }}
          <v-icon>mdi-chevron-down</v-icon>
        </span>
      </v-toolbar-title>
    </template>
    <v-card color="primary">
      <v-list>
        <v-list-item :href="REACT_URL + '/account'">
          <v-list-item-icon>
            <v-icon>mdi-cogs</v-icon>
          </v-list-item-icon>
          <v-list-item-content>Account's options</v-list-item-content>
        </v-list-item>
        <v-subheader>Switch account</v-subheader>
        <v-list-item v-for="acc in accounts.filter(acc => acc.id !== account.id)" :key="acc.id" @click="switchAccount(acc.id)">
          <v-list-item-content>
            {{acc.name}}
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$can('manage', 'Account')" :href="REACT_URL + '/accounts'">
          <v-list-item-content>Manage accounts</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {REACT_URL} from "@/common/config-local";

export default {
  data: () => ({
    REACT_URL
  }),
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    ...mapGetters('account', ['account', 'accounts']),
  },
  mounted() {
    this.getAccounts()
  },
  methods:{
    ...mapActions('account', {getAccounts: 'getList', doSwitchAccount: 'switchAccount'}),
    switchAccount(id){
      this.doSwitchAccount(id)
          .then(() => {
            window.location.reload()
          })
    }
  }
}
</script>